import { useState } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import cn from 'classnames'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Dialog from 'components/Dialog'
import UploadFile from 'components/PosAccounts/UploadOrgAttendants/UploadFile'
import UploadedFile from 'components/PosAccounts/UploadOrgAttendants/UploadedFile'
import ErrorsPreview from 'components/PosAccounts/UploadOrgAttendants/ErrorsPreview'
import Loader from 'components/Loader'

import { getIsLoadingAttendants } from 'store/Attendants/selectors'
import { UPLOAD_ORG_ATTENDANTS_STEPS } from 'resources'

const UploadOrgAttendantsDialog = ({
  isOpen,
  setIsUploadDialogOpen,
}) => {
  const history = useHistory()
  const isLoadingAttendants = useSelector(getIsLoadingAttendants)

  const [file, setFile] = useState(null)
  const [parsedFile, setParsedFile] = useState([])
  const [attendantsWithApiErrors, setAttendantsWithApiErrors] =
    useState([])
  const [step, setStep] = useState(1)

  const handleUploadDialogClose = () => {
    // remove all csv file related data
    setIsUploadDialogOpen(false)
    setFile(null)
    setParsedFile(null)
    setStep(UPLOAD_ORG_ATTENDANTS_STEPS.UPLOAD_FILE)
    history.push({ state: { uploadAttendantsCSVFile: false } })
  }

  const renderStep = () => {
    switch (step) {
      case UPLOAD_ORG_ATTENDANTS_STEPS.UPLOAD_FILE:
        return (
          <UploadFile
            setStep={setStep}
            setFile={setFile}
            isFile={!isEmpty(file)}
            handleUploadDialogClose={handleUploadDialogClose}
          />
        )
      case UPLOAD_ORG_ATTENDANTS_STEPS.UPLOADED_FILE:
        return (
          <UploadedFile
            setStep={setStep}
            setParsedFile={setParsedFile}
            setAttendantsWithApiErrors={setAttendantsWithApiErrors}
            file={file}
            handleUploadDialogClose={handleUploadDialogClose}
          />
        )

      case UPLOAD_ORG_ATTENDANTS_STEPS.ERRORS_PREVIEW:
        return (
          <ErrorsPreview
            attendantsWithApiErrors={attendantsWithApiErrors}
            parsedFile={parsedFile}
            setStep={setStep}
            handleUploadDialogClose={handleUploadDialogClose}
          />
        )

      default:
        return (
          <UploadFile
            setStep={setStep}
            setFile={setFile}
            isFile={!isEmpty(file)}
            handleUploadDialogClose={handleUploadDialogClose}
          />
        )
    }
  }

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleUploadDialogClose}
      classNames={cn('upload-file', {
        '-table-view': [
          UPLOAD_ORG_ATTENDANTS_STEPS.ERRORS_PREVIEW,
        ].includes(step),
      })}
    >
      {renderStep()}
      {isLoadingAttendants && (
        <Loader classNames="upload-file__loader" />
      )}
    </Dialog>
  )
}

UploadOrgAttendantsDialog.propTypes = {
  isOpen: PropTypes.bool,
  setIsUploadDialogOpen: PropTypes.func,
}

export default UploadOrgAttendantsDialog
